module.exports = __webpack_public_path__ + "img/icon_aside_model_active.e1fa71b6.svg";